<script setup lang="ts">
import { RouterLink } from "vue-router";
localStorage.removeItem("code-verifier");
localStorage.removeItem("pn-access-token");
localStorage.removeItem("pn-refresh-token");
localStorage.removeItem("auto-logout-time");
console.log("local storage cleared");
</script>
<template>
  <h1>You've been logged out.</h1>
  <p><RouterLink to="/login">Login</RouterLink></p>
</template>
